import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgbDate, NgbDatepickerI18n, NgbDateStruct, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { Model } from 'src/app/shared/models/clux/model-legacy';

import dayjs from 'dayjs';
import { CustomDatepickerI18n } from '../../utils/custom-datepicker-i18n';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [{ provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbDatepicker, FormsModule, MatFormField, MatLabel, MatInput],
})
export class DatePickerComponent implements OnChanges {
  @Input() public datePicker: boolean;
  @Input() public minDate: NgbDateStruct;
  @Input() public maxDate: NgbDateStruct;
  @Input() public dates: Set<string> = new Set<string>();
  @Input() public currentDate: string;
  @Input() public isDateDisable: boolean;
  @Output() public dateSelection = new EventEmitter<string>();
  @Output() public closeDatePicker = new EventEmitter<boolean>();
  public model: NgbDateStruct;
  public enterDateManually = false;
  public manuallyEnteredDate: string = '';
  public manuallyEnteredDateError: string = '';
  private selectedDate: string;

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLInputElement): boolean {
    if (
      (targetElement.parentElement && targetElement.parentElement.classList.contains('btn-calendar')) ||
      targetElement.classList.contains('btn-calendar') ||
      targetElement.classList.contains('text-muted') ||
      targetElement.classList.contains('disabled') ||
      targetElement.classList.contains('ngb-dp-navigation-chevron') ||
      targetElement.classList.contains('popCalender') ||
      targetElement.classList.contains('right') ||
      targetElement.classList.contains('ngb-dp-arrow-btn') ||
      targetElement.classList.contains('no-border-btn') ||
      targetElement.classList.contains('mat-mdc-input-element') ||
      (targetElement.parentElement && targetElement.parentElement.classList.contains('mdc-floating-label')) ||
      (targetElement.parentElement && targetElement.parentElement.classList.contains('filter-container')) ||
      targetElement.classList.contains('save-btn')
    ) {
      return false;
    } else {
      this.datePicker = false;
    }
  }

  public ngOnChanges(): void {
    if (this.currentDate) {
      const now: Date = new Date(this.currentDate);
      this.model = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    }
  }

  public onDateSelection(event: Model.NgbDate): void {
    this.selectedDate = (event.month + '/' + event.day + '/' + event.year).toString();
    this.datePicker = false;
    this.dateSelection.emit(
      dayjs(event.year + '-' + event.month + '-' + event.day, 'YYYY-M-D')
        .format('YYYY-MM-DD')
        .toString()
    );
    this.closeDatePicker.emit(this.datePicker);
  }

  public saveManuallyEnteredDate(): void {
    const date = dayjs(this.manuallyEnteredDate, 'MM/DD/YYYY', true);
    if (date.isValid()) {
      const ngbDate: NgbDate = new NgbDate(date.year(), date.month() + 1, date.date());
      if (this.isDisabled(ngbDate)) {
        this.manuallyEnteredDateError = 'You must select a valid date.';
      } else {
        this.onDateSelection(ngbDate);
        this.enterDateManually = false;
        this.manuallyEnteredDate = '';
        this.manuallyEnteredDateError = '';
      }
    } else {
      this.manuallyEnteredDateError = 'Invalid date. Please enter a date using mm/dd/yyyy format.';
    }
  }

  /*
  Set focus to the calendar date picker after giving it a short timeout to render.
  This is somewhat hacky, but there doesn't seem to be a better way to do it given how the markup is structured.
  This is implemented in response to QA's insistence that focus go back to the calendar automatically when the user exists the manual date picker.
  */
  public backToCalendarView(): void {
    this.enterDateManually = false;
    setTimeout((): void => {
      (document.getElementsByClassName('ngb-dp-arrow-btn')[0] as HTMLElement).focus();
    }, 100);
  }

  public isDisabled = (date: NgbDateStruct): boolean => {
    if (this.dates?.size > 0) {
      return !this.dates.has(
        dayjs(date.year + '-' + date.month + '-' + date.day, 'YYYY-M-D')
          .format('YYYY-MM-DD')
          .toString()
      );
    } else if (this.isDateDisable) {
      return true;
    }
  };
}
